import { ChevronDown, ChevronUp, Download, Eye, File as FileIcon, Loader2, Paperclip, Plus, Trash2 } from 'lucide-react'
import { canPreview, isVideoFile } from '../../lib/filePreview'
import { isImageAttachment } from './cardDetailUtils'

export default function CardAttachmentsTab({
    t,
    user,
    canContribute,
    fileInputRef,
    onFileUpload,
    uploadingFile,
    attachments,
    isAdmin,
    moveAttachment,
    onRemoveAttachmentRequest,
    procedureFiles,
    openLightbox,
    setPreviewFile,
}) {
    return (
        <div>
            <div className="cd-tab-header">
                <h4 className="cd-tab-title">{t('card.attachments.heading')}</h4>
                {user && canContribute ? (
                    <>
                        <input
                            type="file"
                            multiple
                            ref={fileInputRef}
                            className="cd-file-input-hidden"
                            onChange={onFileUpload}
                        />
                        <button
                            className="btn btn-secondary btn-sm"
                            onClick={() => fileInputRef.current?.click()}
                            disabled={uploadingFile}
                        >
                            {uploadingFile ? <Loader2 size={13} className="spin" /> : <Plus size={13} />} {t('card.attachments.upload')}
                        </button>
                    </>
                ) : user ? (
                    <span className="cd-att-locked-hint">{t('card.attachments.claimFirst')}</span>
                ) : null}
            </div>

            <div className="proc-files-grid">
                {attachments.map((att, index) => {
                    const isImage = att.type?.startsWith('image/')
                    const mine = att.created_by && att.created_by === user?.id
                    const canManage = canContribute && (isAdmin || mine)
                    const uploader = att.profiles?.full_name || t('card.attachments.unknownUser')
                    const previewable = isImage || canPreview(att)
                    const openAtt = () => {
                        if (isImage) {
                            const imgs = attachments.filter(isImageAttachment)
                            openLightbox(imgs, imgs.findIndex((a) => a.id === att.id))
                        } else if (canPreview(att)) {
                            setPreviewFile(att)
                        } else {
                            window.open(att.url, '_blank')
                        }
                    }
                    return (
                        <div key={att.id} className="proc-file-item">
                            {isImage ? (
                                <img src={att.url} alt={att.name} className="proc-file-thumb" onClick={openAtt} title={t('filePreview.open', { defaultValue: 'Previzualizează' })} />
                            ) : isVideoFile(att) ? (
                                <video src={att.url} className="proc-file-thumb" muted preload="metadata" onClick={openAtt} title={t('filePreview.open', { defaultValue: 'Previzualizează' })} />
                            ) : (
                                <button type="button" className="proc-file-thumb proc-file-doc" onClick={openAtt} title={t('filePreview.open', { defaultValue: 'Previzualizează' })}><FileIcon size={20} /></button>
                            )}
                            <div className="proc-file-meta">
                                <button type="button" className="proc-file-name" title={att.name} onClick={openAtt}>{att.name}</button>
                                <span className="proc-file-by">{mine ? t('card.attachments.uploadedByYou', { name: uploader }) : t('card.attachments.uploadedBy', { name: uploader })}</span>
                            </div>
                            <div className="proc-file-actions">
                                {canManage && index > 0 && <button type="button" title={t('card.attachments.moveUp')} onClick={() => moveAttachment(att.id, 'up')}><ChevronUp size={14} /></button>}
                                {canManage && index < attachments.length - 1 && <button type="button" title={t('card.attachments.moveDown')} onClick={() => moveAttachment(att.id, 'down')}><ChevronDown size={14} /></button>}
                                {previewable && <button type="button" title={t('filePreview.open', { defaultValue: 'Previzualizează' })} onClick={openAtt}><Eye size={14} /></button>}
                                <a href={att.url} download={att.name} className="proc-file-dl" title={t('card.attachments.downloadTooltip')}><Download size={14} /></a>
                                {canManage && <button type="button" title={t('card.attachments.deleteTooltip')} onClick={() => onRemoveAttachmentRequest(att)}><Trash2 size={14} /></button>}
                            </div>
                        </div>
                    )
                })}
                {attachments.length === 0 && (
                    <div className="proc-empty" style={{ padding: '20px 0' }}>
                        <Paperclip size={24} strokeWidth={1.5} />
                        <p>{t('card.attachments.empty')}</p>
                    </div>
                )}
            </div>

            {procedureFiles.length > 0 && (
                <div className="cd-procfiles">
                    <div className="cd-procfiles-head">
                        <Paperclip size={13} /> {t('card.attachments.fromProcedure', { defaultValue: 'Fișiere din procedură' })}
                    </div>
                    <div className="cd-procfiles-list">
                        {procedureFiles.map((att) => {
                            const isImage = att.type?.startsWith('image/')
                            const openProcedureFile = () => (canPreview(att) ? setPreviewFile(att) : window.open(att.url, '_blank'))
                            return (
                                <div key={att.id} className="cd-procfile">
                                    {isImage ? (
                                        <img
                                            src={att.url}
                                            alt={att.name}
                                            className="cd-procfile-thumb"
                                            onClick={() => setPreviewFile(att)}
                                            title={t('filePreview.open', { defaultValue: 'Previzualizează' })}
                                        />
                                    ) : (
                                        <button type="button" className="cd-procfile-thumb cd-procfile-doc" onClick={openProcedureFile} title={t('filePreview.open', { defaultValue: 'Previzualizează' })}><FileIcon size={18} /></button>
                                    )}
                                    <button type="button" className="cd-procfile-name" title={att.name} onClick={openProcedureFile}>{att.name}</button>
                                    {canPreview(att) && <button type="button" className="cd-procfile-dl" title={t('filePreview.open', { defaultValue: 'Previzualizează' })} onClick={() => setPreviewFile(att)}><Eye size={14} /></button>}
                                    <a href={att.url} download={att.name} className="cd-procfile-dl" title={t('card.attachments.downloadTooltip')}><Download size={14} /></a>
                                </div>
                            )
                        })}
                    </div>
                </div>
            )}
        </div>
    )
}
